import { render } from "./ArchItem.vue?vue&type=template&id=73faca22&scoped=true"
import script from "./ArchItem.vue?vue&type=script&lang=js"
export * from "./ArchItem.vue?vue&type=script&lang=js"

import "./ArchItem.vue?vue&type=style&index=0&id=73faca22&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73faca22"]])

export default __exports__